import React from "react";
import styled from "styled-components";
import { switchPerformanceColor } from "../Global/tools.js";

import { ReactComponent as PerformanceIndicatorCorner } from "../Global/Icons/PerformanceIndicatorCorner.svg";

const StyledPerformanceIndicator = styled(PerformanceIndicatorCorner)`
  visibility: ${(props) => (props.visible ? "visible" : "hidden")};
  path {
    fill: ${(props) => props.color};
  }
`;

const PerformanceIndicator = (props) => {
  return <StyledPerformanceIndicator color={switchPerformanceColor(props.color)} visible={props.color} />;
};
// Set default props
PerformanceIndicator.defaultProps = {};

export default PerformanceIndicator;
